/* kp-pro.js */
/* KM Motoren / Kemiksiz Performance Automotive Pro v4.0.1 · KBA Edition */
(() => {
  'use strict';

  const root = document.querySelector('[data-kpp-root]');
  if (!root) return;

  const cfg = {
    rootUrl: root.dataset.rootUrl || '/',
    searchUrl: root.dataset.searchUrl || '/search',
    motorenUrl: root.dataset.motorenUrl || '/collections/motoren',
    requestUrl: root.dataset.requestUrl || '/pages/reparaturanfrage',
    whatsapp: (root.dataset.whatsapp || '').replace(/\D/g, ''),
    phone: root.dataset.phone || '',
    phoneLabel: root.dataset.phoneLabel || '',
    business: root.dataset.business || 'Kemiksiz Performance',
    hoursWeekdayStart: root.dataset.hoursWeekdayStart || '',
    hoursWeekdayEnd: root.dataset.hoursWeekdayEnd || '',
    hoursSaturdayStart: root.dataset.hoursSaturdayStart || '',
    hoursSaturdayEnd: root.dataset.hoursSaturdayEnd || '',
    kbaEnabled: root.dataset.kbaEnabled === 'true',
    kbaItemId: String(root.dataset.kbaItemId || 'd277ec18ff1e442597c9411d7c1aaeaa').trim().slice(0,80),
    kbaDatasetDate: String(root.dataset.kbaDatasetDate || '').trim().slice(0,30),
    kbaResultLimit: Math.max(5, Math.min(30, Number(root.dataset.kbaResultLimit || 15))),
    kbaPrefill: root.dataset.kbaPrefill !== 'false',
    kbaSourceUrl: root.dataset.kbaSourceUrl || 'https://data.gov.de/suche/daten/fz-hersteller-handelsnamen-pkw'
  };

  const KEY = {
    garage: 'kp.v3.garage',
    wishlist: 'kp.v3.wishlist',
    compare: 'kp.v3.compare',
    recent: 'kp.v3.recent'
  };

  const MAX = { wishlist: 20, compare: 3, recent: 12 };
  const overlay = root.querySelector('[data-kpp-overlay]');
  const dialog = root.querySelector('[data-kpp-dialog]');
  const live = root.querySelector('[data-kpp-live]');
  const panels = [...root.querySelectorAll('[data-kpp-panel]')];
  const tabs = [...root.querySelectorAll('[data-kpp-tab]')];
  let lastFocus = null;
  let searchTimer = null;
  let searchController = null;

  const esc = (value) => String(value ?? '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#039;');

  const safeParse = (value, fallback) => {
    try { return JSON.parse(value) ?? fallback; } catch (_) { return fallback; }
  };

  const read = (key, fallback) => {
    try { return safeParse(localStorage.getItem(key), fallback); } catch (_) { return fallback; }
  };

  const write = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; }
  };

  const cleanText = (value, max = 120) => String(value ?? '').trim().replace(/\s+/g, ' ').slice(0, max);
  const normalizeCode = (value) => cleanText(value, 80).toUpperCase().replace(/[\s\-_/.]+/g, '');
  const uniq = (arr) => [...new Set(arr.filter(Boolean))];

  const announce = (message) => {
    if (!live) return;
    live.textContent = '';
    window.setTimeout(() => { live.textContent = message; }, 30);
  };

  const event = (name, detail = {}) => {
    if(window.Shopify?.customerPrivacy?.currentVisitorConsent()?.analytics!=='yes')return;
    try {
      window.dispatchEvent(new CustomEvent(name, { detail }));
      window.dispatchEvent(new CustomEvent('kp:analytics', { detail: { name, ...detail } }));
    } catch (_) {}
  };

  const currency = (number) => {
    const value = Number(number || 0);
    if (!Number.isFinite(value) || value <= 0) return 'Preis auf Anfrage';
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: document.body.dataset.kmCurrency || 'EUR' }).format(value); }
    catch (_) { return value.toFixed(2).replace('.', ',') + ' €'; }
  };

  const getGarage = () => {
    const g = read(KEY.garage, {});
    return {
      brand: cleanText(g.brand), model: cleanText(g.model), year: cleanText(g.year, 10),
      engine: cleanText(g.engine), mkb: cleanText(g.mkb, 50), hsn: cleanText(g.hsn, 10), tsn: cleanText(g.tsn, 12)
    };
  };

  const getList = (type) => { const items = read(KEY[type], []); return Array.isArray(items) ? items.filter(item => item && typeof item === 'object' && item.id) : []; };

  const setList = (type, items) => {
    const limit = MAX[type] || 20;
    write(KEY[type], items.slice(0, limit));
    updateCounts();
    renderStored();
  };

  function updateCounts() {
    const wishlist = getList('wishlist').length;
    const compare = getList('compare').length;
    const recent = getList('recent').length;
    root.querySelectorAll('[data-kpp-wishlist-count]').forEach((el) => {
      el.textContent = wishlist; el.classList.toggle('is-visible', wishlist > 0);
    });
    root.querySelectorAll('[data-kpp-compare-count]').forEach((el) => {
      el.textContent = compare; el.classList.toggle('is-visible', compare > 0);
    });
    root.querySelectorAll('[data-kpp-recent-count]').forEach((el) => { el.textContent = recent; });
    root.querySelectorAll('[data-kpp-total-count]').forEach((el) => {
      const total = wishlist + compare;
      el.textContent = total; el.classList.toggle('is-visible', total > 0);
    });
    syncActionStates();
  }

  function switchPanel(name) {
    const finderMode = name === 'kba' ? 'keys' : name === 'vin' ? 'vin' : 'vehicle';
    const selectedTab = name === 'kba' ? 'vehicles' : name;
    if (name === 'kba' || name === 'vin') name = 'vehicles';
    panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.kppPanel === name));
    tabs.forEach((tab) => {
      const active = tab.dataset.kppTab === selectedTab;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    if (name === 'vehicles') window.setTimeout(() => root.querySelector('[data-kmf]')?.dispatchEvent(new CustomEvent('km:finder-mode', { detail: { mode: finderMode } })), 0);
    if (name === 'garage') renderGarage();
    if (name === 'wishlist' || name === 'compare' || name === 'recent') renderStored();
    if (name === 'search') window.setTimeout(() => root.querySelector('[data-kpp-search]')?.focus(), 70);
    if (name === 'kba') window.setTimeout(() => root.querySelector('[data-kpp-kba-form] input[name="hsn"]')?.focus(), 70);
  }

  window.addEventListener('km:garage-updated', () => renderGarage());

  function openHub(name = 'search') {
    if (!overlay || !dialog) return;
    lastFocus = document.activeElement;
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('kpp-no-scroll');
    switchPanel(name);
    window.setTimeout(() => dialog.focus(), 10);
    event(name === 'search' ? 'automotive_search' : name === 'garage' ? 'finder_start' : 'automotive_hub_open', { panel: name });
  }

  function closeHub() {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('kpp-no-scroll');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  root.addEventListener('click', (e) => {
    const open = e.target.closest('[data-kpp-open]');
    if (open) { e.preventDefault(); openHub(open.dataset.kppOpen || 'search'); return; }
    const close = e.target.closest('[data-kpp-close]');
    if (close) { e.preventDefault(); closeHub(); return; }
    const tab = e.target.closest('[data-kpp-tab]');
    if (tab) { switchPanel(tab.dataset.kppTab); return; }
    const go = e.target.closest('[data-kpp-tab-go]');
    if (go) { switchPanel(go.dataset.kppTabGo); return; }
    const contact = e.target.closest('[data-kpp-contact]');
    if (contact) { e.preventDefault(); openWhatsApp(buildGeneralMessage()); return; }
    const b2b = e.target.closest('[data-kpp-b2b]');
    if (b2b) {
      e.preventDefault();
      event('b2b_inquiry_start', {});
      const g = getGarage();
      const lines = [`Hallo ${cfg.business},`, '', 'ich habe eine Werkstatt-/Gewerbeanfrage.', '', 'Firma:', 'Ansprechpartner:', 'Telefon / E-Mail:', '', 'Gesuchter Motor / MKB:', 'Menge:', 'Lieferort:'];
      if (g.mkb || g.brand || g.model) lines.push('', 'Aktuell gespeicherte Fahrzeugdaten:', garageLabel(g));
      openWhatsApp(lines.join('\n'));
    }
  });

  document.addEventListener('click', (e) => {
    const externalOpen = e.target.closest('[data-kpp-open]');
    if (externalOpen && !root.contains(externalOpen)) {
      e.preventDefault();
      openHub(externalOpen.dataset.kppOpen || 'search');
      return;
    }
    const externalB2b = e.target.closest('[data-kpp-b2b]');
    if (externalB2b && !root.contains(externalB2b)) {
      e.preventDefault();
      root.querySelector('[data-kpp-b2b]')?.click();
    }
  });

  overlay?.addEventListener('click', (e) => { if (e.target === overlay) closeHub(); });
  document.addEventListener('keydown', (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); openHub('search'); }
    if (e.key === 'Escape' && overlay?.getAttribute('aria-hidden') === 'false') closeHub();
    if (e.key === 'Tab' && overlay?.getAttribute('aria-hidden') === 'false' && dialog) {
      const focusable = [...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Predictive search */
  const searchInput = root.querySelector('[data-kpp-search]');
  const results = root.querySelector('[data-kpp-results]');
  const spinner = root.querySelector('[data-kpp-spinner]');
  const searchMeta = root.querySelector('[data-kpp-search-meta]');
  const searchForm = root.querySelector('[data-kpp-search-form]');

  function renderSearchState(message, query = '') {
    if (!results) return;
    results.innerHTML = `<div class="kpp-state"><strong>${esc(message)}</strong><p>Kein passender Direkttreffer? Senden Sie Fahrzeugdaten und MKB – so bleibt die Anfrage nicht in einer Sackgasse.</p><div class="kpp-state-actions"><a class="kpp-btn kpp-btn--secondary" href="${esc(cfg.searchUrl)}?type=product&q=${encodeURIComponent(query)}">Gesamte Suche</a><a class="kpp-btn" href="${esc(cfg.requestUrl)}?q=${encodeURIComponent(query)}">Motor anfragen</a></div></div>`;
  }

  function renderSearch(products, query) {
    if (!results) return;
    products = products.filter(p => !/mercedes/i.test(String(p.title || '')));
    const motorProducts = products.filter(p => /motor/i.test(String(p.product_type || p.type || '')) || /motor/i.test(String(p.title || '')));
    const list = (motorProducts.length ? motorProducts : products).slice(0, 8);
    if (!list.length) { renderSearchState('Kein direkter Treffer gefunden.', query); event('finder_no_result', { query }); return; }
    results.innerHTML = list.map(p => {
      const rawImage = p.featured_image?.url || p.image || '';
      const image = /(?:km-b47-n47-original-0|km-n57-original-0|km-m57-306d3-original-0|km-b38-a15a-original-0|kp-14tsi-cax-|kp-20tfsi-gen3-)/i.test(rawImage) ? rawImage : '';
      const price = typeof p.price === 'string' ? Number(p.price) : Number(p.price || 0);
      return `<a class="kpp-result" href="${esc(p.url)}"><span>${image ? `<img src="${esc(image)}" alt="" loading="lazy">` : '<span class="kpp-result__noimg">Produktbild folgt</span>'}</span><span class="kpp-result__body"><span class="kpp-result__type">${esc(p.product_type || 'Produkt')}</span><span class="kpp-result__title">${esc(p.title)}</span></span><span class="kpp-result__price">${esc(/motor/i.test(String(p.product_type || p.type || '')) ? 'Preis im Angebot prüfen' : currency(price))}</span></a>`;
    }).join('');
    event('finder_result', { query, count: list.length });
  }

  const normalizeSearchTerm = value => /^[BMNS]\d{2}\s*[AD]\s*\d{2}[A-Z0-9]*$/i.test(value) ? normalizeCode(value) : cleanText(value,160);
  async function predictiveSearch(query) {
    if (searchController) searchController.abort();
    searchController = new AbortController();
    spinner?.classList.add('is-visible');
    try {
      const url = `${cfg.rootUrl.replace(/\/?$/, '/')}search/suggest.json?q=${encodeURIComponent(normalizeSearchTerm(query))}&resources[type]=product&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,tag,variants.sku,variants.title`;
      const response = await fetch(url, { signal: searchController.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      const products = data?.resources?.results?.products || [];
      if (cleanText(searchInput?.value, 100) === query) renderSearch(products, query);
    } catch (err) {
      if (err?.name !== 'AbortError') renderSearchState('Live-Suche konnte nicht geladen werden.', query);
    } finally { spinner?.classList.remove('is-visible'); }
  }

  searchInput?.addEventListener('input', () => {
    const q = cleanText(searchInput.value, 100);
    clearTimeout(searchTimer);
    if (searchMeta) searchMeta.innerHTML = q ? `<span class="kpp-chip">Suche: ${esc(q)}</span>` : '';
    if (q.length < 2) { searchController?.abort(); if (results) results.innerHTML = ''; spinner?.classList.remove('is-visible'); return; }
    searchTimer = window.setTimeout(() => predictiveSearch(q), 180);
    if (/^[a-z0-9\-\s]{2,12}$/i.test(q)) event('mkb_search', { query: q });
  });

  searchForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    const q = normalizeSearchTerm(cleanText(searchInput?.value, 100));
    if (!q) { searchInput?.focus(); return; }
    window.location.href = `${cfg.searchUrl}?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(q)}`;
  });

  root.querySelector('[data-kpp-mkb-direct]')?.addEventListener('change', (e) => {
    const url = cleanText(e.target.value, 1000);
    if (!url) return;
    event('mkb_search', { source: 'catalog_filter', exact_filter: true });
    window.location.href = url;
  });

  /* Official KBA / GovData HSN-TSN lookup ---------------------------------- */
  const kbaForm = root.querySelector('[data-kpp-kba-form]');
  const kbaResults = root.querySelector('[data-kpp-kba-results]');
  const kbaStatus = root.querySelector('[data-kpp-kba-status]');
  const kbaSpinner = root.querySelector('[data-kpp-kba-spinner]');
  const kbaSubmitLabel = root.querySelector('[data-kpp-kba-submit-label]');
  let kbaContextCache = null;
  let kbaAbort = null;

  const kbaNorm = (value) => String(value || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, '');

  const kbaPickField = (fields, hints, rejects = []) => {
    let best = null, bestScore = -1;
    for (const field of fields || []) {
      const label = kbaNorm(`${field.name || ''} ${field.alias || ''}`);
      if (rejects.some(r => label.includes(kbaNorm(r)))) continue;
      let score = 0;
      hints.forEach((hint, index) => {
        const h = kbaNorm(hint);
        if (!h) return;
        if (kbaNorm(field.name || '') === h || kbaNorm(field.alias || '') === h) score += 20 - index;
        else if (label.includes(h)) score += 10 - Math.min(index, 8);
      });
      if (score > bestScore) { best = field; bestScore = score; }
    }
    return bestScore > 0 ? best : null;
  };

  const kbaSetStatus = (message, state = '') => {
    if (!kbaStatus) return;
    kbaStatus.className = `kpp-kba-status${state ? ` is-${state}` : ''}`;
    kbaStatus.textContent = message || '';
  };

  const kbaFetchJson = async (url, signal) => {
    const response = await fetch(url, { signal, mode: 'cors', credentials: 'omit', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    if (data?.error) throw new Error(data.error.message || 'ArcGIS Fehler');
    return data;
  };

  async function kbaContext(signal) {
    const itemId = String(cfg.kbaItemId || '').replace(/[^a-z0-9]/gi, '');
    if (!itemId) throw new Error('KBA Item-ID fehlt');
    if (kbaContextCache?.itemId === itemId) return kbaContextCache;
    const cached = (() => { try { return safeParse(sessionStorage.getItem('kp.v4.kba.context'), null); } catch (_) { return null; } })();
    if (cached?.itemId === itemId && cached?.layerUrl && cached?.fields?.hsn && cached?.fields?.tsn) {
      kbaContextCache = cached;
      return cached;
    }
    const itemBase = `https://www.arcgis.com/sharing/rest/content/items/${encodeURIComponent(itemId)}`;
    const item = await kbaFetchJson(`${itemBase}?f=json`, signal);
    let serviceUrl = item?.url || '';
    if (!serviceUrl) {
      const itemData = await kbaFetchJson(`${itemBase}/data?f=json`, signal);
      serviceUrl = itemData?.url || itemData?.layers?.[0]?.url || itemData?.operationalLayers?.[0]?.url || '';
    }
    if (!/^https:\/\//i.test(serviceUrl)) throw new Error('Öffentlicher KBA-Datendienst nicht gefunden');
    let layerUrl = serviceUrl.replace(/\/$/, '');
    if (!/(FeatureServer|MapServer)\/\d+$/i.test(layerUrl)) layerUrl += '/0';
    const meta = await kbaFetchJson(`${layerUrl}?f=json`, signal);
    const fields = meta?.fields || [];
    const hsnField = kbaPickField(fields, ['HSN','Herstellerschlüssel','Herstellerschluessel']);
    const tsnField = kbaPickField(fields, ['TSN','Typschlüssel','Typschluessel']);
    const brandField = kbaPickField(fields, ['Herstellername','Hersteller','Marke'], ['Herstellerschlüssel','Herstellerschluessel','HSN']);
    const modelField = kbaPickField(fields, ['Handelsname','Modell','Fahrzeugname'], ['Typschlüssel','Typschluessel','TSN']);
    const typeField = kbaPickField(fields, ['Typbezeichnung','Typ','Baureihe'], ['Typschlüssel','Typschluessel','TSN']);
    if (!hsnField || !tsnField) throw new Error('HSN/TSN-Felder konnten im KBA-Datensatz nicht erkannt werden');
    const context = {
      itemId,
      layerUrl,
      fields: {
        hsn: hsnField.name,
        tsn: tsnField.name,
        hsnType: hsnField.type || '',
        tsnType: tsnField.type || '',
        brand: brandField?.name || '',
        model: modelField?.name || '',
        type: typeField?.name || ''
      }
    };
    kbaContextCache = context;
    try { sessionStorage.setItem('kp.v4.kba.context', JSON.stringify(context)); } catch (_) {}
    return context;
  }

  const kbaSqlValue = (value) => String(value || '').replace(/'/g, "''");
  const kbaIsNumericField = (type) => /(?:Integer|Double|Single|SmallInteger|OID)/i.test(String(type || ''));
  const kbaPredicate = (field, type, value, prefix = false) => {
    const raw = String(value || '').trim();
    if (kbaIsNumericField(type)) {
      const n = Number(raw);
      if (!Number.isFinite(n)) return '1=0';
      return `${field}=${n}`;
    }
    return prefix
      ? `${field} LIKE '${kbaSqlValue(raw)}%'`
      : `${field}='${kbaSqlValue(raw)}'`;
  };

  async function kbaQuery(hsn, tsn, signal) {
    const ctx = await kbaContext(signal);
    const tsn3 = tsn.slice(0, 3);
    const whereExact = `${kbaPredicate(ctx.fields.hsn, ctx.fields.hsnType, hsn)} AND ${kbaPredicate(ctx.fields.tsn, ctx.fields.tsnType, tsn3)}`;
    const run = async (where) => {
      const params = new URLSearchParams({
        f: 'json', where, outFields: '*', returnGeometry: 'false',
        resultRecordCount: String(cfg.kbaResultLimit || 15)
      });
      return kbaFetchJson(`${ctx.layerUrl}/query?${params.toString()}`, signal);
    };
    let data = await run(whereExact);
    if (!(data?.features || []).length) {
      const wherePrefix = `${kbaPredicate(ctx.fields.hsn, ctx.fields.hsnType, hsn)} AND ${kbaPredicate(ctx.fields.tsn, ctx.fields.tsnType, tsn3, true)}`;
      data = await run(wherePrefix);
    }
    const rows = (data?.features || []).map(feature => {
      const a = feature?.attributes || {};
      return {
        hsn: cleanText(a[ctx.fields.hsn] ?? hsn, 12),
        tsn: cleanText(a[ctx.fields.tsn] ?? tsn3, 20).toUpperCase(),
        brand: cleanText(ctx.fields.brand ? a[ctx.fields.brand] : '', 120),
        model: cleanText(ctx.fields.model ? a[ctx.fields.model] : '', 160),
        type: cleanText(ctx.fields.type ? a[ctx.fields.type] : '', 140)
      };
    });
    const seen = new Set();
    return rows.filter(row => {
      const key = kbaNorm([row.hsn,row.tsn,row.brand,row.model,row.type].join('|'));
      if (!key || seen.has(key)) return false;
      seen.add(key); return true;
    }).slice(0, cfg.kbaResultLimit || 15);
  }

  function renderKbaResults(rows, hsn, tsn) {
    if (!kbaResults) return;
    if (!rows.length) {
      kbaResults.innerHTML = `<div class="kpp-state"><strong>Kein eindeutiger KBA-Treffer.</strong><p>Prüfen Sie HSN (Feld 2.1) und die ersten drei Zeichen der TSN (Feld 2.2). Sie können das Fahrzeug trotzdem manuell speichern oder direkt nach MKB suchen.</p><div class="kpp-state-actions"><button class="kpp-btn kpp-btn--secondary" type="button" data-kpp-tab-go="garage">Fahrzeug manuell eingeben</button><button class="kpp-btn" type="button" data-kpp-tab-go="search">MKB suchen</button></div></div>`;
      event('kba_lookup', { found: false, hsn, tsn: tsn.slice(0,3) });
      return;
    }
    kbaResults.innerHTML = `<div class="kpp-kba-result-head"><strong>${rows.length} Fahrzeug${rows.length === 1 ? '' : 'e'} erkannt</strong><span>Quelle: KBA/GovData · MKB muss separat geprüft werden</span></div>` + rows.map((row, index) => {
      const title = uniq([row.brand, row.model]).join(' · ') || 'KBA-Fahrzeugdatensatz';
      const sub = uniq([row.type, `HSN ${row.hsn}`, `TSN ${row.tsn}`]).join(' · ');
      return `<article class="kpp-kba-result"><div class="kpp-kba-result__index">${String(index + 1).padStart(2,'0')}</div><div class="kpp-kba-result__body"><strong>${esc(title)}</strong><span>${esc(sub)}</span><small>Kein MKB aus dieser Datenquelle – bitte ergänzen oder technisch prüfen.</small></div><div class="kpp-kba-result__actions">${cfg.kbaPrefill ? `<button class="kpp-btn kpp-btn--small kpp-btn--secondary" type="button" data-kpp-kba-apply data-brand="${esc(row.brand)}" data-model="${esc(row.model || row.type)}" data-hsn="${esc(row.hsn || hsn)}" data-tsn="${esc(row.tsn || tsn.slice(0,3))}">Übernehmen</button>` : ''}<button class="kpp-btn kpp-btn--small" type="button" data-kpp-kba-search data-brand="${esc(row.brand)}" data-model="${esc(row.model || row.type)}" data-hsn="${esc(row.hsn || hsn)}" data-tsn="${esc(row.tsn || tsn.slice(0,3))}">Motor suchen</button></div></article>`;
    }).join('');
    event('kba_lookup', { found: true, count: rows.length, hsn, tsn: tsn.slice(0,3) });
  }

  async function submitKbaLookup(hsnRaw, tsnRaw) {
    if (!cfg.kbaEnabled) return;
    const hsn = String(hsnRaw || '').replace(/\D/g, '').slice(0,4);
    const tsn = String(tsnRaw || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0,8);
    if (hsn.length !== 4 || tsn.length < 3) {
      kbaSetStatus('Bitte 4-stellige HSN und mindestens die ersten 3 Zeichen der TSN eingeben.', 'error');
      return;
    }
    if (kbaAbort) kbaAbort.abort();
    kbaAbort = new AbortController();
    const activeController = kbaAbort;
    let timedOut = false;
    const timeoutId = window.setTimeout(() => {
      if (kbaAbort === activeController) { timedOut = true; activeController.abort(); }
    }, 12000);
    kbaSpinner?.classList.add('is-visible');
    if (kbaSubmitLabel) kbaSubmitLabel.textContent = 'KBA wird abgefragt …';
    kbaSetStatus('Öffentliche KBA-Fahrzeugdaten werden abgefragt …', 'loading');
    try {
      const rows = await kbaQuery(hsn, tsn, activeController.signal);
      renderKbaResults(rows, hsn, tsn);
      kbaSetStatus(rows.length ? 'Fahrzeuggrunddaten gefunden. Bitte Motorisierung/MKB anschließend abgleichen.' : 'Kein Treffer gefunden.', rows.length ? 'success' : 'notice');
    } catch (err) {
      if (err?.name === 'AbortError' && !timedOut) return;
      const msg = timedOut ? 'Die KBA-Abfrage hat zu lange gedauert. Nutzen Sie MKB-Suche oder manuelle Fahrzeugdaten.' : 'Die öffentliche KBA-Datenquelle ist gerade nicht erreichbar. Nutzen Sie MKB-Suche oder manuelle Fahrzeugdaten.';
      kbaSetStatus(msg, 'error');
      if (kbaResults) kbaResults.innerHTML = `<div class="kpp-state"><strong>KBA-Abfrage derzeit nicht verfügbar.</strong><p>Der Shop bleibt vollständig nutzbar. Suchen Sie direkt nach MKB oder senden Sie Ihre Fahrzeugdaten zur Prüfung.</p><div class="kpp-state-actions"><button class="kpp-btn" type="button" data-kpp-tab-go="search">Motor suchen</button><button class="kpp-btn kpp-btn--secondary" type="button" data-kpp-tab-go="garage">Fahrzeug manuell eingeben</button></div></div>`;
      event('kba_lookup_error', { message: timedOut ? 'timeout' : cleanText(err?.message || 'unknown', 160) });
    } finally {
      window.clearTimeout(timeoutId);
      if (kbaAbort === activeController) kbaAbort = null;
      kbaSpinner?.classList.remove('is-visible');
      if (kbaSubmitLabel) kbaSubmitLabel.textContent = 'Fahrzeug erkennen';
    }
  }

  kbaForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    const data = new FormData(kbaForm);
    submitKbaLookup(data.get('hsn'), data.get('tsn'));
  });

  function applyKbaVehicle(button, searchAfter = false) {
    const current = getGarage();
    const garage = {
      ...current,
      brand: cleanText(button.dataset.brand, 120) || current.brand,
      model: cleanText(button.dataset.model, 160) || current.model,
      hsn: cleanText(button.dataset.hsn, 10).toUpperCase(),
      tsn: cleanText(button.dataset.tsn, 12).toUpperCase()
    };
    write(KEY.garage, garage);
    event('garage_saved', { source: 'kba', has_mkb: !!garage.mkb, has_hsn_tsn: true });
    announce('KBA-Fahrzeugdaten wurden lokal übernommen.');
    renderGarage(); updateCounts();
    if (searchAfter) {
      const q = uniq([garage.mkb, garage.brand, garage.model, garage.engine]).join(' ');
      window.location.href = `${cfg.searchUrl}?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(q || `${garage.brand} ${garage.model}`)}`;
    } else switchPanel('garage');
  }

  root.addEventListener('click', (e) => {
    const apply = e.target.closest('[data-kpp-kba-apply]');
    if (apply) { applyKbaVehicle(apply, false); return; }
    const search = e.target.closest('[data-kpp-kba-search]');
    if (search) { applyKbaVehicle(search, true); return; }
  });

  const homeKbaForm = document.querySelector('[data-kpp-home-kba-form]');
  homeKbaForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    if (!cfg.kbaEnabled) { openHub('garage'); return; }
    const data = new FormData(homeKbaForm);
    const hsn = cleanText(data.get('hsn'), 10);
    const tsn = cleanText(data.get('tsn'), 12).toUpperCase();
    openHub('kba');
    const hsnInput = root.querySelector('[data-kpp-kba-form] input[name="hsn"]');
    const tsnInput = root.querySelector('[data-kpp-kba-form] input[name="tsn"]');
    if (hsnInput) hsnInput.value = hsn;
    if (tsnInput) tsnInput.value = tsn;
    window.setTimeout(() => submitKbaLookup(hsn, tsn), 60);
  });

  /* Garage */
  const garageForm = root.querySelector('[data-kpp-garage-form]');
  const garageSummary = root.querySelector('[data-kpp-garage-summary]');

  function garageLabel(g) {
    return uniq([g.brand, g.model, g.year, g.engine, g.mkb ? `MKB ${g.mkb}` : '']).join(' · ');
  }

  function renderGarage() {
    if (!garageForm) return;
    const g = getGarage();
    ['brand','model','year','engine','mkb','hsn','tsn'].forEach(name => {
      const el = garageForm.elements[name]; if (el) el.value = g[name] || '';
    });
    if (garageSummary) {
      const has = Object.values(g).some(Boolean);
      garageSummary.innerHTML = has ? `<div class="kpp-garage-card"><div class="kpp-garage-card__top"><div><strong>Gespeichertes Fahrzeug</strong><p>${esc(garageLabel(g))}</p></div><button class="kpp-btn kpp-btn--small kpp-btn--secondary" type="button" data-kpp-garage-search>Motor suchen</button></div><div class="kpp-garage-tags">${uniq([g.hsn ? `HSN ${g.hsn}` : '',g.tsn ? `TSN ${g.tsn}` : '']).map(v=>`<span class="kpp-chip">${esc(v)}</span>`).join('')}</div></div><div style="height:.8rem"></div>` : '';
    }
    fillProductFromGarage();
  }

  garageForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    const data = new FormData(garageForm);
    const garage = {
      brand: cleanText(data.get('brand')), model: cleanText(data.get('model')), year: cleanText(data.get('year'), 10),
      engine: cleanText(data.get('engine')), mkb: cleanText(data.get('mkb'), 50).toUpperCase(),
      hsn: cleanText(data.get('hsn'), 10).toUpperCase(), tsn: cleanText(data.get('tsn'), 12).toUpperCase()
    };
    write(KEY.garage, garage);
    event('garage_saved', { has_mkb: !!garage.mkb, has_hsn_tsn: !!(garage.hsn || garage.tsn) });
    announce('Fahrzeug wurde lokal gespeichert.');
    renderGarage(); updateCounts();
  });

  root.addEventListener('click', (e) => {
    const del = e.target.closest('[data-kpp-garage-delete]');
    if (del) { write(KEY.garage, {}); renderGarage(); announce('Gespeicherte Fahrzeugdaten wurden gelöscht.'); return; }
    const search = e.target.closest('[data-kpp-garage-search]');
    if (search) {
      const g = getGarage();
      const q = uniq([g.mkb, g.brand, g.model, g.engine]).join(' ');
      if (!q) { announce('Bitte zuerst Fahrzeugdaten eingeben.'); return; }
      event('finder_step', { step: 'garage_search' });
      window.location.href = `${cfg.searchUrl}?type=product&options%5Bprefix%5D=last&q=${encodeURIComponent(q)}`;
    }
  });

  /* Stored products */
  function productFromElement(el) {
    const card = el.closest('[data-kp-product-card]') || el.closest('[data-kp-product-data]');
    if (!card) return null;
    return {
      id: cleanText(card.dataset.productId || card.dataset.id, 40),
      title: cleanText(card.dataset.productTitle || card.dataset.title, 220),
      url: cleanText(card.dataset.productUrl || card.dataset.url, 500),
      image: cleanText(card.dataset.productImage || card.dataset.image, 800),
      price: cleanText(card.dataset.productPrice || card.dataset.price, 50),
      brand: cleanText(card.dataset.productBrand || card.dataset.brand, 80),
      model: cleanText(card.dataset.productModel || card.dataset.model, 100),
      engine: cleanText(card.dataset.productEngine || card.dataset.engine, 100),
      mkb: cleanText(card.dataset.productMkb || card.dataset.mkb, 120),
      power: cleanText(card.dataset.productPower || card.dataset.power, 80),
      fuel: cleanText(card.dataset.productFuel || card.dataset.fuel, 60),
      cylinders: cleanText(card.dataset.productCylinders || card.dataset.cylinders, 30),
      availability: cleanText(card.dataset.productAvailability || card.dataset.availability, 80),
      sku: cleanText(card.dataset.productSku || card.dataset.sku, 80)
    };
  }

  function hasItem(type, id) { return getList(type).some(item => String(item.id) === String(id)); }

  function toggleList(type, product) {
    if (!product?.id) return;
    let list = getList(type);
    const exists = list.some(item => String(item.id) === String(product.id));
    if (exists) list = list.filter(item => String(item.id) !== String(product.id));
    else {
      if (type === 'compare' && list.length >= MAX.compare) { announce('Im Vergleich sind maximal drei Produkte möglich.'); openHub('compare'); return; }
      list = [product, ...list.filter(item => String(item.id) !== String(product.id))];
    }
    setList(type, list);
    announce(exists ? 'Produkt entfernt.' : type === 'wishlist' ? 'Produkt gemerkt.' : 'Produkt zum Vergleich hinzugefügt.');
    event(type === 'wishlist' ? 'wishlist_add' : 'product_compare_add', { product_id: product.id, added: !exists });
  }

  function syncActionStates() {
    document.querySelectorAll('[data-kp-action="wishlist"],[data-kp-action="compare"]').forEach(btn => {
      const product = productFromElement(btn); if (!product) return;
      const type = btn.dataset.kpAction === 'wishlist' ? 'wishlist' : 'compare';
      const active = hasItem(type, product.id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (type === 'wishlist') btn.setAttribute('aria-label', active ? 'Von Merkliste entfernen' : 'Produkt merken');
      if (type === 'compare') btn.setAttribute('aria-label', active ? 'Aus Vergleich entfernen' : 'Produkt vergleichen');
    });
  }

  document.addEventListener('click', (e) => {
    const action = e.target.closest('[data-kp-action]');
    if (!action) return;
    const type = action.dataset.kpAction;
    if (['wishlist','compare','copy','share','print'].includes(type)) e.preventDefault();
    const p = productFromElement(action);
    if (type === 'wishlist') toggleList('wishlist', p);
    else if (type === 'compare') toggleList('compare', p);
    else if (type === 'copy') copyProductData(p);
    else if (type === 'share') shareProduct(p);
    else if (type === 'print') { event('product_datasheet_print', { product_id: p?.id || '' }); window.print(); }
  });

  function copyText(text) {
    if (navigator.clipboard?.writeText) return navigator.clipboard.writeText(text);
    return new Promise((resolve, reject) => {
      try {
        const area = document.createElement('textarea');
        area.value = text; area.setAttribute('readonly', ''); area.style.position = 'fixed'; area.style.opacity = '0';
        document.body.appendChild(area); area.select();
        const ok = document.execCommand('copy'); area.remove();
        ok ? resolve() : reject(new Error('copy failed'));
      } catch (error) { reject(error); }
    });
  }

  function copyProductData(p) {
    if (!p) return;
    const lines = [p.title, new URL(p.url || window.location.href, window.location.origin).href];
    [['MKB',p.mkb],['Marke',p.brand],['Modell / Baureihe',p.model],['Motorisierung',p.engine],['Leistung',p.power],['Kraftstoff',p.fuel],['Zylinder',p.cylinders],['SKU',p.sku],['Verfügbarkeit',p.availability],['Preis',p.price]].forEach(([label,value]) => { if (value) lines.push(`${label}: ${value}`); });
    copyText(lines.join('\n')).then(() => announce('Produktdaten wurden kopiert.')).catch(() => announce('Produktdaten konnten nicht automatisch kopiert werden.'));
    event('product_data_copy', { product_id: p.id || '' });
  }

  function shareProduct(p) {
    const url = p?.url ? new URL(p.url, window.location.origin).href : window.location.href;
    const title = p?.title || document.title;
    if (navigator.share) navigator.share({ title, url }).catch(() => {});
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => announce('Produktlink kopiert.')).catch(() => {});
    event('product_share', { product_id: p?.id || '' });
  }

  function removeStored(type, id) { setList(type, getList(type).filter(item => String(item.id) !== String(id))); }

  root.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-kpp-remove]');
    if (remove) { removeStored(remove.dataset.type, remove.dataset.id); return; }
    const moveCompare = e.target.closest('[data-kpp-add-compare]');
    if (moveCompare) {
      const p = getList('wishlist').find(item => String(item.id) === String(moveCompare.dataset.id));
      if (p) toggleList('compare', p);
    }
  });

  function savedItem(item, type) {
    item={...item,image:/(?:km-b47-n47-original-0|km-n57-original-0|km-m57-306d3-original-0|km-b38-a15a-original-0|kp-14tsi-cax-|kp-20tfsi-gen3-)/i.test(item.image||'')?item.image:''};
    return `<div class="kpp-saved-item"><span>${item.image ? `<img src="${esc(item.image)}" alt="" loading="lazy">` : '<span class="kpp-result__noimg">Produktbild folgt</span>'}</span><div><a class="kpp-saved-item__title" href="${esc(item.url)}">${esc(item.title || 'Produkt')}</a><div class="kpp-saved-item__meta">${[item.mkb ? `MKB ${item.mkb}` : '',item.power,item.availability].filter(Boolean).map(v=>`<span>${esc(v)}</span>`).join('<span>·</span>')}</div></div><div class="kpp-saved-item__actions">${type === 'wishlist' ? `<button class="kpp-btn kpp-btn--small kpp-btn--secondary" type="button" data-kpp-add-compare data-id="${esc(item.id)}">Vergleichen</button>` : ''}<button class="kpp-remove" type="button" data-kpp-remove data-type="${type}" data-id="${esc(item.id)}" aria-label="Entfernen">×</button></div></div>`;
  }

  function compareTable(list) {
    list=list.map(item=>({...item,image:/(?:km-b47-n47-original-0|km-n57-original-0|km-m57-306d3-original-0|km-b38-a15a-original-0|kp-14tsi-cax-|kp-20tfsi-gen3-)/i.test(item.image||'')?item.image:''}));
    if (!list.length) return '<div class="kpp-state"><strong>Noch keine Produkte im Vergleich.</strong><p>Fügen Sie auf einer Produkt- oder Katalogseite bis zu drei Motoren hinzu.</p><div class="kpp-state-actions"><a class="kpp-btn" href="' + esc(cfg.motorenUrl) + '">Motoren ansehen</a></div></div>';
    const rows = [
      ['MKB','mkb'],['Marke','brand'],['Modell / Baureihe','model'],['Motorisierung','engine'],['Leistung','power'],['Kraftstoff','fuel'],['Zylinder','cylinders'],['SKU','sku'],['Verfügbarkeit','availability'],['Preis','price']
    ];
    const body = rows.map(([label,key]) => {
      const vals = list.map(i => cleanText(i[key]) || '—');
      const diff = new Set(vals).size > 1;
      return `<tr data-kpp-diff="${diff ? '1' : '0'}"><th>${esc(label)}</th>${vals.map(v=>`<td>${esc(v)}</td>`).join('')}</tr>`;
    }).join('');
    return `<table class="kpp-compare-table"><thead><tr><th>Merkmal</th>${list.map(i=>`<td class="kpp-compare-product">${i.image ? `<img src="${esc(i.image)}" alt="" loading="lazy">` : ''}<a href="${esc(i.url)}">${esc(i.title)}</a><button class="kpp-remove" type="button" data-kpp-remove data-type="compare" data-id="${esc(i.id)}" aria-label="Aus Vergleich entfernen">×</button></td>`).join('')}</tr></thead><tbody>${body}</tbody></table>`;
  }

  function renderStored() {
    const wishEl = root.querySelector('[data-kpp-wishlist-list]');
    const recentEl = root.querySelector('[data-kpp-recent-list]');
    const compareEl = root.querySelector('[data-kpp-compare-list]');
    const wishlist = getList('wishlist'), recent = getList('recent'), compare = getList('compare');
    if (wishEl) wishEl.innerHTML = wishlist.length ? wishlist.map(i => savedItem(i,'wishlist')).join('') : `<div class="kpp-state"><strong>Merkliste ist leer.</strong><p>Speichern Sie interessante Motoren direkt im Katalog oder auf der Produktseite.</p><div class="kpp-state-actions"><a class="kpp-btn" href="${esc(cfg.motorenUrl)}">Motoren ansehen</a></div></div>`;
    if (recentEl) recentEl.innerHTML = recent.length ? recent.map(i => savedItem(i,'recent')).join('') : '<div class="kpp-state"><strong>Noch keine Produkte angesehen.</strong><p>Hier erscheinen automatisch die zuletzt geöffneten Produktseiten dieses Browsers.</p></div>';
    if (compareEl) compareEl.innerHTML = compareTable(compare);
    const diff = root.querySelector('[data-kpp-diff-only]');
    if (diff?.checked && compareEl) compareEl.querySelectorAll('tr[data-kpp-diff="0"]').forEach(row => row.hidden = true);
  }

  root.querySelector('[data-kpp-diff-only]')?.addEventListener('change', (e) => {
    root.querySelectorAll('[data-kpp-compare-list] tr[data-kpp-diff="0"]').forEach(row => row.hidden = e.target.checked);
    event('product_compare_open', { differences_only: e.target.checked });
  });

  /* Product page integration */
  const productDataEl = document.querySelector('[data-kp-current-product]');
  if (productDataEl) {
    const product = productFromElement(productDataEl);
    if (product?.id && window.Shopify?.customerPrivacy?.currentVisitorConsent()?.preferences === 'yes') {
      const recent = [product, ...getList('recent').filter(i => String(i.id) !== String(product.id))].slice(0, MAX.recent);
      write(KEY.recent, recent);
      updateCounts();
    }
  }

  function fillProductFromGarage() {
    const g = getGarage();
    const map = {
      'kpmp-marke': g.brand, 'kpmp-modell': g.model, 'kpmp-baujahr': g.year,
      'kpmp-motorisierung': g.engine, 'kpmp-mkb': g.mkb, 'kpmp-hsn': g.hsn, 'kpmp-tsn': g.tsn
    };
    Object.entries(map).forEach(([id,val]) => { const el = document.getElementById(id); if (el && val && !el.value) el.value = val; });
    const hint = document.querySelector('[data-kp-garage-fill]');
    if (hint && Object.values(g).some(Boolean)) {
      hint.classList.add('is-visible');
      const copy = hint.querySelector('[data-kp-garage-copy]'); if (copy) copy.textContent = garageLabel(g);
    }
    syncLineProperties(); compatibilityCheck();
  }

  document.addEventListener('click', (e) => {
    const apply = e.target.closest('[data-kp-apply-garage]');
    if (apply) { fillProductFromGarage(); announce('Gespeicherte Fahrzeugdaten wurden übernommen.'); }
  });

  ['kpmp-marke','kpmp-modell','kpmp-baujahr','kpmp-motorisierung','kpmp-mkb','kpmp-hsn','kpmp-tsn','kpmp-fin'].forEach(id => {
    document.getElementById(id)?.addEventListener('input', () => { syncLineProperties(); compatibilityCheck(); });
  });

  function syncLineProperties() {
    const fields = {
      'kp-prop-brand':'kpmp-marke','kp-prop-model':'kpmp-modell','kp-prop-year':'kpmp-baujahr',
      'kp-prop-engine':'kpmp-motorisierung','kp-prop-mkb':'kpmp-mkb','kp-prop-hsn':'kpmp-hsn','kp-prop-tsn':'kpmp-tsn','kp-prop-vin':'kpmp-fin'
    };
    Object.entries(fields).forEach(([hiddenId,inputId]) => {
      const hidden = document.getElementById(hiddenId), input = document.getElementById(inputId);
      if (hidden && input) hidden.value = cleanText(input.value, hiddenId === 'kp-prop-vin' ? 30 : 120);
    });
  }

  function compatibilityCheck() {
    const output = document.querySelector('[data-kp-compat-result]');
    const product = productDataEl ? productFromElement(productDataEl) : null;
    const input = document.getElementById('kpmp-mkb');
    if (!output || !product || !input) return;
    const user = normalizeCode(input.value);
    const productCodes = String(product.mkb || '').split(/[,;|/\s]+/).map(normalizeCode).filter(Boolean);
    if (!user) { output.className = 'kpmp-compat-result'; output.textContent = ''; return; }
    const exact = productCodes.includes(user);
    output.className = 'kpmp-compat-result is-visible' + (exact ? ' is-match' : '');
    output.innerHTML = exact
      ? '<strong>Exakter MKB-Treffer in den hinterlegten Produktdaten.</strong><br>Das ist ein starkes Indiz, ersetzt aber keine vollständige Fahrzeug- und Ausführungsprüfung.'
      : '<strong>Kein exakter MKB-Treffer in den aktuell hinterlegten Produktdaten.</strong><br>Bitte Kompatibilität vor dem Kauf prüfen lassen; fehlende oder unvollständige Produktdaten sind möglich.';
    event('compatibility_check', { exact_mkb: exact, product_id: product.id });
  }

  /* Product fit WhatsApp is handled in the product section; enrich global contact links */
  function buildGeneralMessage() {
    const g = getGarage();
    const lines = [`Hallo ${cfg.business},`, '', 'ich habe eine Anfrage zu meinem Fahrzeug.'];
    if (Object.values(g).some(Boolean)) {
      lines.push('', 'FAHRZEUGDATEN');
      [['Marke',g.brand],['Modell',g.model],['Baujahr',g.year],['Motorisierung',g.engine],['Motorkennbuchstabe',g.mkb],['HSN',g.hsn],['TSN',g.tsn]].forEach(([k,v]) => { if (v) lines.push(`${k}: ${v}`); });
    }
    lines.push('', 'Anliegen:', '');
    return lines.join('\n');
  }

  function openWhatsApp(message) {
    if (!cfg.whatsapp) { window.location.href = cfg.requestUrl; return; }
    event('whatsapp_product_click', { context: 'global_hub' });
    window.open(`https://wa.me/${cfg.whatsapp}?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
  }

  /* Opening status: only shown when hours are explicitly configured */
  function parseTime(value) {
    const m = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(value || '');
    return m ? Number(m[1]) * 60 + Number(m[2]) : null;
  }

  function updateOpeningStatus() {
    const wrap = root.querySelector('[data-kpp-opening-status]');
    const copy = root.querySelector('[data-kpp-opening-copy]');
    if (!wrap || !copy) return;
    if (!cfg.hoursWeekdayStart || !cfg.hoursWeekdayEnd) return;
    try {
      const parts = new Intl.DateTimeFormat('de-DE',{timeZone:'Europe/Berlin',weekday:'short',hour:'2-digit',minute:'2-digit',hour12:false}).formatToParts(new Date());
      const val = Object.fromEntries(parts.map(p=>[p.type,p.value]));
      const weekdays = {Mo:1,Di:2,Mi:3,Do:4,Fr:5,Sa:6,So:7};
      const day = weekdays[val.weekday?.replace('.','')] || 7;
      const now = Number(val.hour) * 60 + Number(val.minute);
      let start = null, end = null;
      if (day <= 5) { start = parseTime(cfg.hoursWeekdayStart); end = parseTime(cfg.hoursWeekdayEnd); }
      if (day === 6) { start = parseTime(cfg.hoursSaturdayStart); end = parseTime(cfg.hoursSaturdayEnd); }
      const open = start !== null && end !== null && now >= start && now < end;
      wrap.hidden = false; wrap.classList.toggle('is-open', open);
      copy.textContent = open ? `Aktuell erreichbar · bis ${day === 6 ? cfg.hoursSaturdayEnd : cfg.hoursWeekdayEnd} Uhr` : 'Aktuell außerhalb der hinterlegten Öffnungszeiten';
    } catch (_) {}
  }

  document.addEventListener('click', (e) => {
    const phone = e.target.closest('a[href^="tel:"]');
    if (phone) event('phone_click', { href: phone.getAttribute('href') || '' });
    const wa = e.target.closest('a[href*="wa.me"]');
    if (wa) event('whatsapp_product_click', { context: productDataEl ? 'product_link' : 'site_link' });
    const recentLink = e.target.closest('[data-kpp-recent-list] a[href]');
    if (recentLink) event('recently_viewed_click', { href: recentLink.getAttribute('href') || '' });
  });

  /* Collection finder: auto-submit only when user explicitly clicks submit; selects mirror real Shopify filters. */
  document.querySelectorAll('[data-kp-finder-select]').forEach(select => {
    select.addEventListener('change', () => {
      event('finder_step', { filter: select.dataset.kpFinderSelect || '', selected: !!select.value });
      const form = select.closest('form');
      if (form) {
        form.setAttribute('aria-busy', 'true');
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
      }
    });
  });

  renderGarage();
  renderStored();
  updateCounts();
  updateOpeningStatus();
})();

;
/* kp-premium-v5.js */
(() => {
  const ready = () => {
    document.documentElement.classList.add('kpv5-ready');
    const header = document.querySelector('[data-kpv5-header]');
    const onScroll = () => header?.classList.toggle('is-scrolled', window.scrollY > 120);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const revealEls = [...document.querySelectorAll('[data-kpv5-reveal]')];
    if (!revealEls.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      revealEls.forEach(el => el.classList.add('is-visible'));
    } else {
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: .08 });
      revealEls.forEach(el => io.observe(el));
    }

    document.querySelectorAll('[data-kpv5-mobile-menu] a, [data-kpv5-mobile-menu] button').forEach(el => {
      el.addEventListener('click', () => {
        const details = el.closest('details');
        if (details && el.tagName === 'A') details.open = false;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();

;
/* kp-premium-v6.js */
/* KM Motoren / Kemiksiz Performance — Ultimate storefront layer v6 */
(function(){
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  function q(sel,ctx){return (ctx||doc).querySelector(sel);}
  function qa(sel,ctx){return Array.prototype.slice.call((ctx||doc).querySelectorAll(sel));}

  /* Scroll progress */
  var progress = doc.createElement('div');
  progress.className = 'kpv6-scroll-progress';
  progress.setAttribute('aria-hidden','true');
  doc.body.appendChild(progress);
  function updateProgress(){
    var h = Math.max(1, doc.documentElement.scrollHeight - window.innerHeight);
    var pct = Math.min(100, Math.max(0, (window.scrollY / h) * 100));
    progress.style.width = pct + '%';
  }
  window.addEventListener('scroll',updateProgress,{passive:true});
  window.addEventListener('resize',updateProgress,{passive:true});
  updateProgress();

  /* Discreet desktop back-to-top control. */
  var backTop=doc.createElement('button');
  backTop.type='button';
  backTop.className='kpv6-backtop';
  backTop.setAttribute('aria-label','Zurück nach oben');
  backTop.innerHTML='<span aria-hidden="true">↑</span>';
  doc.body.appendChild(backTop);
  function updateBackTop(){backTop.classList.toggle('is-visible',window.scrollY>700);}
  backTop.addEventListener('click',function(){window.scrollTo({top:0,behavior:(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)?'auto':'smooth'});});
  window.addEventListener('scroll',updateBackTop,{passive:true});
  updateBackTop();

  /* Tiny noise layer for depth */
  var noise = doc.createElement('div');
  noise.className = 'kpv6-page-noise';
  noise.setAttribute('aria-hidden','true');
  doc.body.appendChild(noise);

  /* Reveal only when motion is allowed */
  var revealNodes = qa('[data-kpv6-reveal]');
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    revealNodes.forEach(function(el){el.classList.add('is-in');});
  }else if('IntersectionObserver' in window){
    var revealObserver = new IntersectionObserver(function(entries,obs){
      entries.forEach(function(entry){
        if(entry.isIntersecting){entry.target.classList.add('is-in');obs.unobserve(entry.target);}
      });
    },{rootMargin:'0px 0px -5% 0px',threshold:.08});
    revealNodes.forEach(function(el){revealObserver.observe(el);});
  }else{
    revealNodes.forEach(function(el){el.classList.add('is-in');});
  }

  /* Keep page-builder/merchant RTE content inside viewport even if it contains inline widths. */
  qa('.kppage-content--contained [style]').forEach(function(el){
    if(el.scrollWidth > el.clientWidth + 8){
      el.style.maxWidth = '100%';
      el.style.overflowWrap = 'anywhere';
    }
  });

  /* Premium cart context note — no checkout lock, just a technical reminder. */
  function enhanceCart(){
    qa('#cart-drawer .cart-items__table-row').forEach(function(row){
      if(row.dataset.kpv6Enhanced) return;
      row.dataset.kpv6Enhanced = '1';
      var title = q('.cart-items__title,.cart-items__title a',row);
      if(title && /motor/i.test(title.textContent||'')) row.classList.add('is-kpv6-motor');
    });
  }
  enhanceCart();
  var cartObserver = new MutationObserver(function(){enhanceCart();});
  var cart = q('#cart-drawer');
  if(cart) cartObserver.observe(cart,{childList:true,subtree:true});

  /* Social dock: generated from the footer social links, so there is one source of truth. */
  var socialSource = q('.kpv5-footer .kpv6-socials');
  var showDock = doc.body.getAttribute('data-kpv6-social-dock') === 'true';
  if(showDock && socialSource && socialSource.children.length){
    var dock = doc.createElement('aside');
    dock.className = 'kpv6-social-dock';
    dock.setAttribute('aria-label','Social Media Schnellzugriff');
    var clone = socialSource.cloneNode(true);
    clone.classList.remove('kpv6-socials--labels');
    qa('span',clone).forEach(function(s){s.remove();});
    dock.appendChild(clone);
    doc.body.appendChild(dock);
  }


  /* Close desktop mega menus on outside click / Escape. */
  doc.addEventListener('click',function(ev){
    qa('[data-kpv6-mega][open]').forEach(function(menu){if(!menu.contains(ev.target)) menu.removeAttribute('open');});
  });
  doc.addEventListener('keydown',function(ev){
    if(ev.key==='Escape') qa('[data-kpv6-mega][open]').forEach(function(menu){menu.removeAttribute('open');});
  });

  /* Theme editor re-renders sections without a full navigation. */
  doc.addEventListener('shopify:section:load',function(){
    qa('[data-kpv6-reveal]').forEach(function(el){el.classList.add('is-in');});
    enhanceCart();
  });
})();

;
/* kp-ultimate-v7.js */
/* KM Motoren / Kemiksiz Performance — Ultimate Automotive v7 */
(function(){
  'use strict';
  var d=document, w=window;
  function q(s,c){return (c||d).querySelector(s)}
  function qa(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))}
  function reduced(){return !!(w.matchMedia&&w.matchMedia('(prefers-reduced-motion: reduce)').matches)}

  /* Reveal system — progressive enhancement only. */
  function initReveal(root){
    var nodes=qa('[data-kpv7-reveal]',root||d).filter(function(el){return !el.dataset.kpv7RevealInit});
    nodes.forEach(function(el){el.dataset.kpv7RevealInit='1'});
    if(!nodes.length)return;
    if(reduced()||!('IntersectionObserver' in w)){nodes.forEach(function(el){el.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(entries,obs){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');obs.unobserve(e.target)}})},{threshold:.07,rootMargin:'0px 0px -5% 0px'});
    nodes.forEach(function(el){io.observe(el)});
  }
  initReveal();

  /* Header reading/progress indicator. */
  var progress=q('[data-kpv7-header-progress]');
  function updateProgress(){if(!progress)return;var max=Math.max(1,d.documentElement.scrollHeight-w.innerHeight);progress.style.width=Math.min(100,Math.max(0,w.scrollY/max*100))+'%'}
  w.addEventListener('scroll',updateProgress,{passive:true});w.addEventListener('resize',updateProgress,{passive:true});updateProgress();

  /* Mega menus: close siblings, outside click, Escape. */
  qa('[data-kpv7-mega]').forEach(function(menu){
    menu.addEventListener('toggle',function(){if(menu.open)qa('[data-kpv7-mega]').forEach(function(other){if(other!==menu)other.removeAttribute('open')})});
  });
  d.addEventListener('click',function(ev){qa('[data-kpv7-mega][open]').forEach(function(menu){if(!menu.contains(ev.target))menu.removeAttribute('open')})});
  d.addEventListener('keydown',function(ev){if(ev.key==='Escape')qa('[data-kpv7-mega][open]').forEach(function(menu){menu.removeAttribute('open')})});

  /* Mark the current destination consistently in desktop, mobile and footer navigation. */
  function markCurrentNavigation(){
    var currentPath=(w.location.pathname||'/').replace(/\/+$/,'')||'/';
    var currentHash=w.location.hash||'';
    qa('.kpv7-header nav a[href],.kpv7-mobile-drawer nav a[href],.kpv7-footer__links a[href]').forEach(function(link){
      try{
        var url=new URL(link.getAttribute('href'),w.location.origin);
        var path=(url.pathname||'/').replace(/\/+$/,'')||'/';
        var samePage=url.origin===w.location.origin&&path===currentPath;
        var sameTarget=url.hash?url.hash===currentHash:!currentHash;
        if(samePage&&sameTarget)link.setAttribute('aria-current','page');
        else link.removeAttribute('aria-current');
      }catch(error){}
    });
    qa('.kpv7-mega').forEach(function(menu){
      var summary=q(':scope>summary',menu);
      if(!summary)return;
      if(q('a[aria-current="page"]',menu))summary.setAttribute('aria-current','page');
      else summary.removeAttribute('aria-current');
    });
  }
  markCurrentNavigation();
  w.addEventListener('hashchange',markCurrentNavigation,{passive:true});

  /* Footer "to top". */
  qa('[data-kpv7-top]').forEach(function(el){el.addEventListener('click',function(ev){ev.preventDefault();w.scrollTo({top:0,behavior:reduced()?'auto':'smooth'})})});

  /* Desktop social dock, generated from configured footer channels. */
  function initSocialDock(){
    if(q('.kpv7-social-dock'))return;
    var source=q('.kpv7-socials--footer');
    if(!source||!source.children.length||d.body.getAttribute('data-kpv6-social-dock')!=='true')return;
    var dock=d.createElement('aside');dock.className='kpv7-social-dock';dock.setAttribute('aria-label','Social Media Schnellzugriff');
    var clone=source.cloneNode(true);clone.className='kpv7-socials kpv7-socials--dock';qa('span',clone).forEach(function(s){if(!s.classList.contains('kpv7-social-glyph'))s.remove()});dock.appendChild(clone);d.body.appendChild(dock);
  }
  initSocialDock();

  /* Cart drawer technical assistant — informational, never blocks checkout. */
  function enhanceCartDrawer(){
    if(d.body.getAttribute('data-kpv7-cart-assistant')==='false')return;
    var drawer=q('#cart-drawer,.cart-drawer');if(!drawer)return;
    var motorRows=qa('.cart-items__table-row.is-kpv6-motor,.cart-items__table-row',drawer).filter(function(row){return /motor/i.test(row.textContent||'')});
    var existing=q('[data-kpv7-cart-assistant]',drawer);
    if(!motorRows.length){if(existing)existing.remove();return}
    if(existing)return;
    var box=d.createElement('aside');box.className='kpv7-cart-assistant';box.setAttribute('data-kpv7-cart-assistant','');
    box.innerHTML='<span>TECHNISCHER CHECK</span><strong>Motorzuordnung vor Versand noch einmal abgleichen.</strong><p>MKB, HSN/TSN und Fahrzeugdaten helfen bei der Prüfung. Der Hinweis sperrt den Checkout nicht.</p><div><button type="button" data-kpp-open="garage">Fahrzeug öffnen</button><button type="button" data-kpp-open="search">Motorfinder</button></div>';
    var target=q('.cart-drawer__summary,.cart-drawer__footer,.cart-drawer__items',drawer);if(target)target.parentNode.insertBefore(box,target);else drawer.appendChild(box);
  }
  enhanceCartDrawer();
  var cartRoot=q('#cart-drawer,.cart-drawer');if(cartRoot)new MutationObserver(function(){enhanceCartDrawer()}).observe(cartRoot,{childList:true,subtree:true});

  /* Protect unknown merchant-authored rich text from horizontal blowouts at runtime. */
  function containLegacy(root){qa('.kppage-content--contained [style]',root||d).forEach(function(el){if(el.scrollWidth>d.documentElement.clientWidth){el.style.maxWidth='100%';el.style.left='auto';el.style.marginLeft='0';el.style.overflowWrap='break-word'}})}
  containLegacy();

  /* Product 3D state badge: only shown when Shopify actually provides model media. */
  if(q('.kpv6-product-media--model'))d.documentElement.classList.add('kpv7-has-3d-product');


  /* Privacy-friendly storefront interaction events; no analytics provider is installed. */
  d.addEventListener('click',function(ev){
    var social=ev.target.closest&&ev.target.closest('.kpv7-socials a,.kpv7-wa-float');
    if(social){try{w.dispatchEvent(new CustomEvent('social_contact_click',{detail:{label:social.getAttribute('aria-label')||social.textContent.trim(),href:social.getAttribute('href')||''}}))}catch(e){}}
    var brand=ev.target.closest&&ev.target.closest('.kpv7-brand-card,.kpv7-brand-tile');
    if(brand){try{w.dispatchEvent(new CustomEvent('automotive_brand_click',{detail:{label:(brand.querySelector('strong')||brand).textContent.trim()}}))}catch(e){}}
    var service=ev.target.closest&&ev.target.closest('.kpv7-service-card');
    if(service){try{w.dispatchEvent(new CustomEvent('service_navigation_click',{detail:{label:(service.querySelector('h3')||service).textContent.trim()}}))}catch(e){}}
    var xr=ev.target.closest&&ev.target.closest('[data-shopify-xr]');
    if(xr){try{w.dispatchEvent(new CustomEvent('product_3d_ar_open',{detail:{model_id:xr.getAttribute('data-shopify-model3d-id')||''}}))}catch(e){}}
  });

  /* Theme editor support. */
  d.addEventListener('shopify:section:load',function(ev){initReveal(ev.target);containLegacy(ev.target);setTimeout(function(){initSocialDock();enhanceCartDrawer()},50)});
})();

;
/* kp-remastered-v75.js */
/* KM Motoren v7.5 Remastered — progressive visual enhancements only. */
(() => {
  'use strict';
  const doc = document;
  const root = doc.documentElement;
  const body = doc.body;
  if (!body) return;

  body.dataset.kpv75 = 'ready';

  const header = doc.querySelector('[data-kpv7-header]');
  const setScrollState = () => {
    const y = window.scrollY || 0;
    body.classList.toggle('kpv75-scrolled', y > 18);
    if (header) header.style.setProperty('--kpv75-scroll', Math.min(y / 260, 1).toFixed(3));
  };
  setScrollState();
  window.addEventListener('scroll', setScrollState, { passive: true });

  if (window.matchMedia('(hover:hover) and (pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const tiltTargets = [...doc.querySelectorAll('.kpv7-engine-stage,.kpv7-service-card.is-main,.kpmp-main-media')];
    tiltTargets.forEach((el) => {
      el.setAttribute('data-kpv75-tilt', '');
      el.addEventListener('pointermove', (event) => {
        const rect = el.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - .5;
        const y = (event.clientY - rect.top) / rect.height - .5;
        el.style.setProperty('--kpv75-ry', `${(x * 2.2).toFixed(2)}deg`);
        el.style.setProperty('--kpv75-rx', `${(-y * 1.8).toFixed(2)}deg`);
      });
      el.addEventListener('pointerleave', () => {
        el.style.setProperty('--kpv75-ry', '0deg');
        el.style.setProperty('--kpv75-rx', '0deg');
      });
    });
  }

  // Add a compact visual state to remembered / compared product buttons after the core KP script updates aria-pressed.
  const syncActionButtons = () => {
    doc.querySelectorAll('[data-kp-action="wishlist"],[data-kp-action="compare"]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.getAttribute('aria-pressed') === 'true');
    });
  };
  syncActionButtons();
  const observer = new MutationObserver(syncActionButtons);
  observer.observe(body, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });

  root.classList.add('kpv75-js');
})();

;
/* kp-polish-v757.js */
/* KM v7.5.7: German interface labels for Shopify's dynamically inserted consent UI.
   Native inputs, event handlers and consent storage remain owned by Shopify. */
(() => {
  'use strict';
  if (!/^de(?:-|$)/i.test(document.documentElement.lang) && !document.body.classList.contains('k9')) return;

  const translations = new Map([
    ['Cookie and privacy preferences', 'Cookie-Einstellungen'],
    ['Accept all', 'Alle akzeptieren'],
    ['Decline all', 'Alle ablehnen'],
    ['Save my choices', 'Auswahl speichern'],
    ['You control your data', 'Sie entscheiden über Ihre Daten'],
    ['Learn more about the cookies we use, and choose which cookies to allow.', 'Erfahren Sie, welche Cookies wir verwenden, und wählen Sie aus, welche Sie zulassen möchten.'],
    ['Required', 'Notwendig'],
    ['Personalization', 'Personalisierung'],
    ['Analytics', 'Statistik'],
    ['These cookies are necessary for the site to function properly, including capabilities like logging in and adding items to the cart.', 'Diese Cookies sind für die Funktionen der Website erforderlich, etwa für die Anmeldung und den Warenkorb.'],
    ['These cookies store details about your actions to personalize your next visit to the website.', 'Diese Cookies speichern Informationen über Ihre Nutzung, um Ihren nächsten Besuch auf der Website zu personalisieren.'],
    ['These cookies are used by us and our partners, including Shopify, to optimize marketing communications and show you ads on other websites.', 'Wir und unsere Partner, einschließlich Shopify, verwenden diese Cookies, um Marketing-Mitteilungen zu optimieren und Ihnen Werbung auf anderen Websites anzuzeigen.'],
    ['These cookies help us understand how you interact with the site. We use this data to identify areas to improve.', 'Diese Cookies helfen uns zu verstehen, wie Sie die Website nutzen. Wir verwenden diese Daten, um Verbesserungsmöglichkeiten zu erkennen.']
  ]);

  function translateConsent(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement?.closest('script, style, svg')) continue;
      const original = node.nodeValue.trim();
      const translation = translations.get(original);
      if (translation) node.nodeValue = node.nodeValue.replace(original, translation);
    }
    const close = root.querySelector('#shopify-pc__prefs__header-close');
    if (close?.getAttribute('aria-label') === 'Close dialog') close.setAttribute('aria-label', 'Cookie-Einstellungen schließen');
  }

  function init() {
    // Footer already contains the same finder and social actions. Give it a clear
    // reading area instead of covering its links with duplicate floating controls.
    const footer = document.querySelector('.kpv7-footer');
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        document.body.classList.toggle('km-footer-in-view', entries[0].isIntersecting);
      }).observe(footer);
    }
    // Translate only Shopify's interface heading, never headings inside legal text.
    const heading = document.querySelector('.shopify-policy__title h1');
    const titles = new Map([
      ['Terms of service', 'Allgemeine Geschäftsbedingungen'],
      ['Privacy policy', 'Datenschutz'], ['Shipping policy', 'Versand'],
      ['Refund policy', 'Rückgabe & Widerruf'], ['Legal notice', 'Impressum'],
      ['Contact information', 'Kontaktinformationen']
    ]);
    if (heading && titles.has(heading.textContent.trim())) heading.textContent = titles.get(heading.textContent.trim());

    function inspect(node) {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      const root = node.closest('#shopify-pc__prefs, #shopify-pc__banner');
      if (root) translateConsent(root);
      else node.querySelectorAll('#shopify-pc__prefs, #shopify-pc__banner').forEach(translateConsent);
    }
    inspect(document.body);
    new MutationObserver(records => {
      const changed = new Set();
      records.forEach(record => {
        if (record.target.nodeType === Node.ELEMENT_NODE && record.target.closest('#shopify-pc__prefs, #shopify-pc__banner')) changed.add(record.target);
        record.addedNodes.forEach(node => { if (node.nodeType === Node.ELEMENT_NODE) changed.add(node); });
      });
      changed.forEach(inspect);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

;
/* km-storefront.js */
/* KM Motoren 8.2.0. Delegated UI handlers; Shopify retains checkout and product data. */
(() => {
  'use strict';
  if (window.__kmStorefront) return;
  window.__kmStorefront = true;
  const doc = document;
  doc.documentElement.classList.add('km-js');
  const $ = (selector, root = doc) => root.querySelector(selector);
  const $$ = (selector, root = doc) => [...root.querySelectorAll(selector)];
  const mobile = matchMedia('(max-width: 900px)');
  let active = null;
  let returnFocus = null;
  let filterBackdrop = null;
  let privacyReady;
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const focusables = root => $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]', root).filter(el => el.getClientRects().length);

  function closeOverlay(restore = true) {
    if (!active) return;
    const old = active;
    active = null;
    old.classList.remove('is-open');
    if (old.matches('[data-kpv7-mobile-drawer]')) {
      old.hidden = true;
      old.setAttribute('aria-hidden', 'true');
      $$('[data-kpv7-mobile-toggle]').forEach(el => { el.setAttribute('aria-expanded', 'false'); el.setAttribute('aria-label', 'Menü öffnen'); });
    }
    if (old.matches('[data-km-filters]')) {
      old.removeAttribute('role'); old.removeAttribute('aria-modal');
      $$('[data-km-filters-open]').forEach(el => el.setAttribute('aria-expanded', 'false'));
      filterBackdrop?.remove(); filterBackdrop = null;
    }
    if (old.matches('[data-kpv6-privacy-modal]')) old.setAttribute('aria-hidden', 'true');
    doc.body.classList.remove('km-modal-open');
    if (restore && returnFocus?.isConnected) returnFocus.focus();
  }

  function openOverlay(el, opener) {
    if (!el) return;
    closeOverlay(false);
    active = el;
    returnFocus = opener || doc.activeElement;
    el.hidden = false;
    el.setAttribute('aria-hidden', 'false');
    el.classList.add('is-open');
    doc.body.classList.add('km-modal-open');
    if (el.matches('[data-km-filters]')) {
      el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true');
      filterBackdrop = doc.createElement('button');
      filterBackdrop.className = 'km-filter-backdrop';
      filterBackdrop.type = 'button';
      filterBackdrop.setAttribute('aria-label', 'Filter schließen');
      filterBackdrop.tabIndex = -1;
      filterBackdrop.addEventListener('click', () => closeOverlay());
      el.before(filterBackdrop);
    }
    requestAnimationFrame(() => { if (active === el) focusables(el)[0]?.focus(); });
  }

  function privacyAPI() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!privacyReady) privacyReady = new Promise(resolve => {
      if (!window.Shopify?.loadFeatures) { resolve(null); return; }
      const timeout = setTimeout(() => resolve(null), 6000);
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        clearTimeout(timeout); resolve(error ? null : window.Shopify.customerPrivacy || null);
      });
    });
    return privacyReady;
  }
  function savedChoice() {
    try {
      const saved = JSON.parse(localStorage.getItem('kpv6_privacy_choice_v1') || 'null');
      if (saved?.savedAt > Date.now() - 31536000000 && saved.savedAt <= Date.now()) return saved;
    } catch (_) { /* Browser storage is optional. */ }
    try {
      const match = doc.cookie.split('; ').find(value => value.startsWith('kpv6_privacy_choice_v1='));
      const saved = match ? JSON.parse(decodeURIComponent(match.split('=').slice(1).join('='))) : null;
      return saved?.savedAt > Date.now() - 31536000000 && saved.savedAt <= Date.now() ? saved : null;
    } catch (_) { return null; }
  }
  function hideCookie() {
    const banner = $('[data-kpv6-cookie]');
    if (banner) { banner.hidden = true; banner.classList.remove('is-visible'); }
  }
  function nativeBannerVisible() {
    return $$('#shopify-pc__banner,.shopify-pc__banner__dialog').some(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  }
  function syncConsent(api) {
    let consent = savedChoice()?.values || {};
    try { consent = api?.currentVisitorConsent() || consent; } catch (_) { /* Keep last UI choice. */ }
    $$('[data-kpv6-consent]').forEach(input => { const value = consent[input.dataset.kpv6Consent]; input.checked = value === true || value === 'yes'; });
  }
  async function initPrivacy() {
    const banner = $('[data-kpv6-cookie]');
    if (!banner) return;
    const api = await privacyAPI();
    syncConsent(api);
    let show = !savedChoice();
    try { if(api){ const current=api.currentVisitorConsent();const decided=['analytics','marketing','preferences'].every(key=>['yes','no'].includes(current[key]));show=!decided&&!savedChoice();Object.entries(current).forEach(([key,value])=>banner.setAttribute('data-consent-'+key,String(value))); } } catch (_) {}
    if (show && !nativeBannerVisible()) {
      banner.hidden = false; banner.classList.add('is-visible');
      const observer = new MutationObserver(() => { if (nativeBannerVisible() || banner.hidden) { hideCookie(); observer.disconnect(); } });
      observer.observe(doc.body, { childList: true, subtree: true });
      doc.addEventListener('visitorConsentCollected', () => observer.disconnect(), { once: true });
    }
    else hideCookie();
  }
  async function saveConsent(values, button) {
    const buttons = $$('[data-kpv6-cookie] button,[data-kpv6-privacy-modal] button');
    buttons.forEach(el => el.disabled = true);
    let success = false;
    try {
      const api = await privacyAPI();
      if (!api) { privacyReady = null; throw new Error('Privacy API unavailable'); }
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('Consent timeout')), 6000);
        api.setTrackingConsent(values, error => { clearTimeout(timeout); error?.error ? reject(error) : resolve(); });
      });
      const current=api.currentVisitorConsent();
      for (const [key,value] of Object.entries(values)) if(current[key] !== (value?'yes':'no')) throw new Error('Consent was not applied');
      Object.entries(current).forEach(([key,value])=>$('[data-kpv6-cookie]').setAttribute('data-consent-'+key,String(value)));
      const saved = JSON.stringify({ savedAt: Date.now(), values });
      try { localStorage.setItem('kpv6_privacy_choice_v1', saved); } catch (_) { /* Cookie fallback below. */ }
      doc.cookie = 'kpv6_privacy_choice_v1=' + encodeURIComponent(saved) + '; Max-Age=31536000; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
      hideCookie(); closeOverlay(); success = true;
      doc.dispatchEvent(new CustomEvent('kpv6:privacy-saved', { detail: values }));
    } catch (_) {
      const surface = button.closest('[data-kpv6-cookie],[data-kpv6-privacy-modal]');
      let status = $('[data-km-consent-status]', surface);
      if (!status) { status = doc.createElement('p'); status.dataset.kmConsentStatus = ''; status.setAttribute('role', 'status'); (surface.querySelector('.kpv6-privacy-card') || surface).append(status); }
      status.textContent = 'Die Cookie-Auswahl konnte gerade nicht gespeichert werden. Bitte erneut versuchen.';
    } finally {
      buttons.forEach(el => el.disabled = false);
      if (success) $$('[data-km-consent-status]').forEach(el => el.remove());
    }
  }

  function init(root = doc) {
    root.classList?.add('km-ready');
    const drawer = $('[data-kpv7-mobile-drawer]', root);
    if (drawer && drawer.parentNode !== doc.body) {
      $$('body > [data-kpv7-mobile-drawer]').forEach(old => { if (old !== drawer) old.remove(); });
      doc.body.append(drawer);
    }
    $$('[data-kpv7-reveal],[data-kpv6-reveal]', root).forEach(el => el.classList.add('is-in'));
  }

  doc.addEventListener('click', event => {
    const target = event.target.closest('button,a,[data-kpv7-mobile-close]');
    if (!target) return;
    if (target.matches('[data-kpv7-mobile-toggle]')) {
      event.preventDefault();
      const drawer = $('[data-kpv7-mobile-drawer]');
      if (active === drawer) closeOverlay();
      else { openOverlay(drawer, target); target.setAttribute('aria-expanded', 'true'); target.setAttribute('aria-label', 'Menü schließen'); }
    } else if (target.matches('[data-kpv7-mobile-close],[data-km-filters-close],[data-kpv6-privacy-close]')) {
      event.preventDefault(); closeOverlay();
    } else if (target.matches('[data-km-filters-open]')) {
      event.preventDefault(); openOverlay(doc.getElementById(target.getAttribute('aria-controls')), target); target.setAttribute('aria-expanded', 'true');
    } else if (target.matches('[data-kpv6-cookie-settings],[data-kpv6-open-privacy]')) {
      event.preventDefault(); privacyAPI().then(syncConsent); openOverlay($('[data-kpv6-privacy-modal]'), target);
    } else if (target.matches('[data-kpv6-cookie-essential],[data-kpv6-privacy-essential]')) {
      saveConsent({ preferences: false, analytics: false, marketing: false }, target);
    } else if (target.matches('[data-kpv6-cookie-all]')) {
      saveConsent({ preferences: true, analytics: true, marketing: true }, target);
    } else if (target.matches('[data-kpv6-privacy-save]')) {
      const values = {}; $$('[data-kpv6-consent]').forEach(input => values[input.dataset.kpv6Consent] = input.checked); saveConsent(values, target);
    }
  });
  // Close navigation before the existing finder receives its delegated click.
  doc.addEventListener('click', event => {
    if (active?.matches('[data-kpv7-mobile-drawer]') && event.target.closest('a,[data-kpp-open]')) closeOverlay(false);
    if (event.target === active && active?.matches('[data-kpv6-privacy-modal]')) closeOverlay();
  }, true);
  doc.addEventListener('keydown', event => {
    if (!active) return;
    if (event.key === 'Escape') { event.preventDefault(); closeOverlay(); return; }
    if (event.key !== 'Tab') return;
    const items = focusables(active), first = items[0], last = items.at(-1);
    if (!first) return;
    if (event.shiftKey && (doc.activeElement === first || !active.contains(doc.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (doc.activeElement === last || !active.contains(doc.activeElement))) { event.preventDefault(); first.focus(); }
  });
  window.addEventListener('resize', () => {
    if (active?.matches('[data-km-filters]') && !mobile.matches) closeOverlay();
    if (active?.matches('[data-kpv7-mobile-drawer]') && innerWidth > 1240) closeOverlay();
  }, { passive: true });
  doc.addEventListener('visitorConsentCollected', () => { hideCookie(); privacyAPI().then(syncConsent); });
  doc.addEventListener('shopify:section:load', event => init(event.target));
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', () => { init(); initPrivacy(); }, { once: true });
  else { init(); initPrivacy(); }
})();

(() => {
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('.k9-search,.km-search')) return;
    const input = form.querySelector('[name="q"]');
    const term = input?.value.trim() || '';
    if (/^[BMNS]\d{2}\s*[AD]\s*\d{2}[A-Z0-9]*$/i.test(term)) input.value = term.toUpperCase().replace(/\s+/g, '');
  }, true);
})();
